// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import styles from './CheckBoxCardV2.module.scss';
import React from 'react';
import { CustomCheckBoxV2 } from 'components/atoms/CustomCheckboxV2';
import { mergeClasses } from 'util/commons';

interface Props {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  id?: string;
  children?: React.ReactNode;
  childCSS?: string;
  checkCardCSS?: string;
  type?: 'dark' | 'green' | 'default';
  enableCardClick?: boolean;
}

export function CheckBoxCardV2({
  onChange,
  id,
  checked,
  children,
  childCSS,
  checkCardCSS,
  type,
  enableCardClick = false,
}: Props) {
  const handleCardClick = () => {
    const syntheticEvent = {
      target: {
        checked: !checked,
      },
      currentTarget: {
        checked: !checked,
      },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange && onChange(syntheticEvent);
  };

  return (
    <div
      className={mergeClasses(checkCardCSS ? checkCardCSS : styles.checkCard, {
        [styles.bgCheckboxCardGreen]:
          enableCardClick && type === 'green' && checked,
      })}
      onClick={enableCardClick ? handleCardClick : undefined}
      style={{
        cursor: enableCardClick ? 'pointer' : 'default',
      }}
    >
      <div
        onClick={(e) => {
          if (enableCardClick) {
            e.stopPropagation();
          }
        }}
      >
        <CustomCheckBoxV2
          id={id}
          type={type}
          checked={checked}
          onChange={(value) =>
            onChange?.(value as React.ChangeEvent<HTMLInputElement>)
          }
        />
      </div>
      <div className={childCSS ? childCSS : styles.children}>{children}</div>
    </div>
  );
}
